module.exports = __webpack_public_path__ + "static/media/TransactionHorizontal.8a39db64.png";